export const outdatedOutfitCategoryTuningTest = ({
  buildsignature,
  categoryid,
  createtime,
  desyncdata,
  desyncid,
  screenshot,
  sessionid,
  sku,
  systemconfig,
  type,
  version,
}) => {
  if (desyncdata !== undefined) {
    if (desyncdata.indexOf('AttributeError: \'tuple\' object has no attribute \'buffs\'') !== -1) {
      return {
        type: 'outdatedOutfitCategoryTuningTest',
        color: 'IndianRed',
        title: 'Outdated Outfit Category Tuning Error',
        text: 'Outdated mods related to outfits or CAS.',
        description: 'An outdated override modification that modify outfits behavior.<br/><br/>' +
        'You need to locate the PACKAGE file, in your The Sims 4 Mods folder, that could be causing this issue and remove it. Try starting with the oldest modifications you have.<br/>' +
        'If this is a new issue, try removing the most recent mod you have installed.'
      }
    }
  }
}

// EXAMPLE
/*
<root>
  <report>
    <version>2</version>
    <sessionid>6a86e3deabcbb59f5b64d612</sessionid>
    <type>desync</type>
    <sku>ea.maxis.sims4.13.pc</sku>
    <createtime>2099-08-03 18:34:44</createtime>
    <buildsignature>Local.Unknown.Unknown.1.99.62.1020-1.200.000.360.Release</buildsignature>
    <categoryid>sim.py:3613</categoryid>
    <desyncid>6a86e3deabcbb59f5b64d612</desyncid>
    <systemconfig/>
    <screenshot/>
    <desyncdata>Exception in Sim Timeline: Exception resuming Element (AttributeError: 'tuple' object has no attribute 'buffs')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 217, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 385, in _resume
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 2611, in _startup_sim_gen
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 3599, in on_outfit_changed
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 3613, in apply_outfit_buffs_for_sim_info
AttributeError: 'tuple' object has no attribute 'buffs'
</desyncdata>
  </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/outdatedOutfitCategoryTuningTest.js